import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthLayout, { inputCls, btnPrimary } from "@/pages/AuthLayout";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { applyAuth } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const intent = params.get("intent");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      applyAuth(data);
      toast.success("Account created.");
      nav(intent ? `/app/account?intent=${intent}#upgrade` : "/app");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthLayout title="Create your account" subtitle={intent ? "Create an account, then complete your purchase on the next screen." : "Start with a free preview — unlock a part or the bundle any time."}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-sm text-nm-ink font-medium">Name</label>
          <input required value={name} onChange={(e) => setName(e.target.value)} className={`${inputCls} mt-1.5`} placeholder="Your name" data-testid="register-name" />
        </div>
        <div>
          <label className="text-sm text-nm-ink font-medium">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mt-1.5`} placeholder="you@company.com" data-testid="register-email" />
        </div>
        <div>
          <label className="text-sm text-nm-ink font-medium">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputCls} mt-1.5`} placeholder="At least 6 characters" data-testid="register-password" />
        </div>
        <button type="submit" disabled={loading} className={btnPrimary} data-testid="register-submit">
          {loading ? "Creating…" : <>Create account <ArrowRight size={16} /></>}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-nm-neutral">
        Already have an account? <Link to="/login" className="text-nm-coral font-medium hover:underline" data-testid="to-login">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
